
import { useEffect } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { WorkTypeDDLAPI } from '../../Redux/DDLSlice'
import { AstricSign } from '../../Helper/AstricSign'

export const WorkTypeDDL = (props) => {
    const { WorkType, setWorkType, rowData, Flag, IsPost, IsDisabled, ActiveBtn, isDisplay } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = { UserID, token }
        dispatch(WorkTypeDDLAPI({ data }))
    }, [IsPost && IsPost])

    const { WorkTypeData } = useSelector(state => state.WorkTypeDDLData)


    useEffect(() => {
        handleWorkTypeDDL()
    }, [WorkTypeData])

    const handleWorkTypeDDL = () => {
        // console.log('DeptDDLDataa', WorkTypeData?.table[0])
        if (WorkTypeData && WorkTypeData.table && WorkTypeData.table.length > 0) {
            let list = WorkTypeData.table.map((item, index) => ({
                value: item.workTypeID,
                label: item.workTypeName,
            }))
            if (ActiveBtn && ActiveBtn == "Dashboard Official Visit") {
                setWorkType({
                    DDL: list,
                    ID: WorkTypeData?.table ? WorkTypeData?.table[0]?.workTypeID : 0,
                    Label: WorkTypeData?.table ? WorkTypeData?.table[0]?.workTypeName : "Select WorkType",
                })
            } else {
                setWorkType({
                    DDL: list,
                    ID: Flag === 'Update' ? rowData.m_WorkTypeID : 0,
                    Label: Flag === 'Update' ? rowData.workTypeName : "Select WorkType",
                })
            }

        }
        else {
            setWorkType({
                DDL: [],
                ID: 0,
                Label: "Select WorkType",
            })
        }

    }

    return (
        <div className="form-group">
            {
                (isDisplay && isDisplay == true) &&
                <label className="d-block" htmlFor="NameofWorkType"><b>Work Type {Flag && <AstricSign />} </b></label>
            }
            <Select
                isClearable
                // isRtl={isRtl}
                isDisabled={Flag === 'Update' && IsDisabled ? true : false}
                className=""
                isSearchable
                maxMenuHeight={115}
                value={{ value: WorkType.ID, label: WorkType.Label }}
                onChange={(e) => {
                    e ?
                        setWorkType({ ...WorkType, ID: e.value, Label: e.label })
                        :
                        setWorkType({ ...WorkType, ID: 0, Label: "Select WorkType" })
                }}
                options={WorkType.DDL}
            />
        </div>
    )
}